import { makeUseAnalytics } from '@plato/app-core/hooks/make-use-analytics';
import type { AnalyticsEvents } from '../types/analytics-events.ts';

export const useAnalytics = makeUseAnalytics<AnalyticsEvents>();
